import { Field } from "../FieldHandler";
import { ChangeEvent, FC, useCallback } from "react";

const NumberField: FC<{
  field: Field & { type: "number" };
  onChange: (key: string, value: number) => void;
  onBlur?: (field: Field) => void;
}> = ({ field, onChange, onBlur }) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(field.key, Number.parseFloat(e.target.value));
    },
    [field, onChange]
  );

  const handleBlur = useCallback(() => {
    if (!onBlur) {
      return;
    }
    onBlur(field);
  }, [onBlur, field]);

  return (
    <span>
      <input
        type="number"
        value={field.value || undefined}
        placeholder={field.required ? "required" : ""}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </span>
  );
};

export default NumberField;
